module.exports = __webpack_public_path__ + "img/gettysburg-national-park-commission.366deadd.png";